import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getDealerAverageTrendData,
  getDealerFilter,
  getDealerPartDetails,
  getDealerReport,
  getDealerTableData,
  getDepartmentGraph,
} from "../api/dealerTop50";

export const fetchDepartmentGraph = createAsyncThunk(
  "dealerTop50/fetchDepartmentGraph",
  async (params) =>
    getDepartmentGraph(
      params?.department,
      params?.page,
      params?.limit,
      params?.type
    )
);

export const fetchDealerTableData = createAsyncThunk(
  "dealerTop50/fetchDealerTableData",
  async (params) =>
    getDealerTableData(
      params?.type,
      params?.page,
      params?.limit,
      params?.parts,
      params?.sortColumn,
      params?.sortOrder
    )
);

export const fetchDealerFilter = createAsyncThunk(
  "dealerTop50/fetchDealerFilter",
  async () => getDealerFilter()
);

export const fetchDealerAverageTrendData = createAsyncThunk(
  "dealerTop50/fetchDealerAverageTrendData",
  async (params) =>
    getDealerAverageTrendData(
      params?.startDate,
      params?.endDate,
      params?.page,
      params?.limit,
      params?.type
    )
);

export const fetchDealerReport = createAsyncThunk(
  "dealerTop50/fetchDealerReport",
  async (params) =>
    getDealerReport(
      params?.startDate,
      params?.endDate,
      params?.type,
      params?.department
    )
);

export const fetchDealerPartDetails = createAsyncThunk(
  "dealerTop50/fetchDealerPartDetails",
  async (params) =>
    getDealerPartDetails(
      params?.page,
      params?.limit,
      params?.type,
      params?.search
    )
);

export const dealerTop50Slice = createSlice({
  name: "dealerTop50",
  initialState: {
    departmentGraphData: null,
    tableData: null,
    typeFilterData: null,
    averageTrendData: null,
    dealerReportData: null,
    dealerPartDetails: null,
    loading: false,
  },
  extraReducers: {
    [fetchDepartmentGraph.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchDepartmentGraph.fulfilled]: (state, { payload }) => {
      state.departmentGraphData = payload;
      state.loading = false;
    },
    [fetchDepartmentGraph.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchDealerTableData.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchDealerTableData.fulfilled]: (state, { payload }) => {
      state.tableData = payload;
      state.loading = false;
    },
    [fetchDealerTableData.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchDealerFilter.fulfilled]: (state, { payload }) => {
      state.typeFilterData = payload.map((item) =>
        item.type?.split("_").join(" ")
      );
    },
    [fetchDealerAverageTrendData.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchDealerAverageTrendData.fulfilled]: (state, { payload }) => {
      state.averageTrendData = payload;
      state.loading = false;
    },
    [fetchDealerAverageTrendData.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchDealerReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchDealerReport.fulfilled]: (state, { payload }) => {
      state.dealerReportData = payload;
      state.loading = false;
    },
    [fetchDealerReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchDealerPartDetails.fulfilled]: (state, { payload }) => {
      state.dealerPartDetails = payload;
    },
  },
});

export default dealerTop50Slice.reducer;
